import Vue from 'vue'
import Vuex from 'vuex'

// general
import sidebar from '@/store/modules/sidebar';
import accounts from '@/store/modules/accounts';
import catalogs from '@/store/modules/catalogs';
import files from '@/store/modules/files';
import notification from '@/store/modules/notification';
/* import settings from '@/store/modules/settings'; */

// views
import sessionStore from '@/views/session/store';
import pushNotificationsStore from '@/views/pushNotification/store';
import orderEmisionStore from '@/views/orderEmision/store';
import commissionStore from '@/views/commission/store';
import bonusComplianceStore from '@/views/bonusCompliance/store';
import bonusProductionStore from '@/views/bonusProduction/store';
import bonusCategoryStore from '@/views/bonusCategory/store';
import quotingStore from '@/views/quoting/store';
import imageStore from '@/views/image/store';
import userStore from '@/views/user/store';
import commercialStore from '@/views/commercial/store';
import electtronicDocumentStore from '@/views/electtronicDocument/store';
import electronicBillingStore from '@/views/electronicBilling/store';
import productionReportStore from '@/views/productionReport/store';
import linkFormStore from '@/views/linkForm/store';
import ecommerceStore from '@/views/ecommerce/store';
import carteraStore from '@/views/cartera/store';
import cotizadorStore from '@/views/cotizador/store';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        sidebar,
        accounts,
        catalogs,
        files,
        notification,
        /* settings, */

        sessionStore,
        pushNotificationsStore,
        orderEmisionStore,
        commissionStore,
        bonusComplianceStore,
        bonusProductionStore,
        bonusCategoryStore,
        quotingStore,
        imageStore,
        userStore,
        commercialStore,
        electtronicDocumentStore,
        electronicBillingStore,
        productionReportStore,
        linkFormStore,
        carteraStore,
        ecommerceStore,
        cotizadorStore
    }
})